import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import Beta from './pages/Beta';
import Home from './pages/Home';
import Delivery from './pages/Delivery';
import Project from './pages/Project';
import DPO from './pages/DPO';
import SIEM from './pages/SIEM';
import Search from './pages/Search';
import JoinUs from './pages/JoinUs';
import AboutUs from './pages/AboutUs';

import { Login, CourseRecommender } from './components/LMSComponents';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/ProtectedRoute'; // Import the ProtectedRoute component

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Beta />} />
        <Route 
          path="/home" 
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/login" 
          element={
            <ProtectedRoute>
              <Login />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/courses" 
          element={
            <ProtectedRoute>
              <CourseRecommender />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/delivery" 
          element={
            <ProtectedRoute>
              <Delivery />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/project" 
          element={
            <ProtectedRoute>
              <Project />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/dpo" 
          element={
            <ProtectedRoute>
              <DPO />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/siem" 
          element={
            <ProtectedRoute>
              <SIEM />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/search" 
          element={
            <ProtectedRoute>
              <Search />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/joinus" 
          element={
            <ProtectedRoute>
              <JoinUs />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/aboutus" 
          element={
            <ProtectedRoute>
              <AboutUs />
            </ProtectedRoute>
          } 
        />
        <Route path="/joinus" element={<JoinUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
